import {
  CreateDeviceSchema,
  type DeviceCreateRequest,
} from '@quromedical/models';
import { Row } from 'components/base';
import { CrudForm, type SubmissionHandler } from 'components/form';
import { Alert, Skeleton, SkeletonProvider, Snackbar } from 'design-system';
import { router } from 'expo-router';
import { logger } from 'helpers';
import { useRevalidation } from 'hooks/useRevalidation';
import { DeviceApi } from 'integration/aggregate';
import type React from 'react';
import { useCallback, useState } from 'react';
import { strings } from 'strings';

import { deviceFormFields } from './internal';

const initialDevice = {};

export const CreateDeviceForm: React.FC = () => {
  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(false);
  const revalidate = useRevalidation('Device');

  const onSubmit = useCallback<SubmissionHandler<DeviceCreateRequest>>(
    async (device: DeviceCreateRequest) => {
      console.log('submitting device', device);
      setLoading(true);
      try {
        const api = new DeviceApi();
        const result = await api.createDevice(device);

        if (result) {
          router.push({
            pathname: `/admin/device/${result.id}`,
          });
        }
        await revalidate();
        setLoading(false);
        return {};
      } catch (error) {
        logger.error(error);
        setHasError(true);
        setLoading(false);
        return { error };
      }
    },
    [revalidate],
  );

  const onAlertClose = useCallback(() => {
    setHasError(false);
  }, []);

  return (
    <SkeletonProvider loading={loading}>
      <Row alignItems="center" justifyContent="space-between" unsetZIndex>
        <Skeleton>
          <CrudForm
            title={strings.CreateDevice}
            fields={deviceFormFields}
            showSubmitButton={true}
            initialValues={initialDevice}
            validationSchema={CreateDeviceSchema}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onSubmit={onSubmit}
          />
        </Skeleton>
        <Snackbar isOpen={hasError} onClose={onAlertClose}>
          <Alert
            actionIcon="close"
            backgroundColor="status-critical"
            title={strings.AlertError}
            onAction={onAlertClose}
            body={strings.DeviceCreateError}
          />
        </Snackbar>
      </Row>
    </SkeletonProvider>
  );
};
